export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7449.5a356e9a.jpg";